import { toast } from 'sonner';
import React from 'react';

/**
 * D5. Undo toast for destructive actions.
 *
 *   undoToast({
 *     label: "Deleted 'Coastal Beach'",
 *     onUndo: async () => { await restore(); }
 *   })
 *
 * Toast auto-dismisses after 6s. Undo action calls onUndo() and shows
 * a success toast on completion.
 */
export function undoToast({ label, onUndo, duration = 6000, description }) {
  toast(label, {
    description,
    duration,
    action: onUndo
      ? {
          label: 'Undo',
          onClick: async () => {
            try {
              await onUndo();
              toast.success('Undone');
            } catch (e) {
              toast.error('Undo failed');
            }
          },
        }
      : undefined,
  });
}

/**
 * Confirm + delete + undo helper. Skips the confirm dialog if the caller
 * already confirmed. Fires the deletion, then shows an undo toast that
 * calls `onRestore()` if clicked.
 *
 *   await deleteWithUndo({
 *     confirm: 'Delete this product?',
 *     onDelete: async () => api.delete(...),
 *     onRestore: async () => api.post('/restore', ...),
 *     label: 'Product deleted'
 *   })
 */
export async function deleteWithUndo({ confirm, onDelete, onRestore, label = 'Deleted' }) {
  if (confirm && !window.confirm(confirm)) return false;
  try {
    await onDelete();
    undoToast({ label, onUndo: onRestore });
    return true;
  } catch (e) {
    toast.error(e?.response?.data?.detail || e?.message || 'Delete failed');
    return false;
  }
}
